import './card.css';
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Divider, Loader, Modal } from "rsuite"
import { char } from "../../../../../utils";
import { useReactToPrint } from "react-to-print";
import { Image } from "antd";
import { appCRUD } from "../../../../../actions/app";
import Confirmation from "../../../../../utils/confirmation";
import { selector } from '../../../../../api';


export const AddCard = (props) => {
    const {open, setOpen, data, index, setIndex} = props;
    const [loading, setLoading] = useState(false);
    const [printCompleted, setPrintCompleted] = useState(false);
    const [front, setFront] = useState(true);
    const [almanac, setAlmanac] = useState(null)
    const [study, setStudy] = useState(null);
    const [back, setBack] = useState(false);
    const user = selector.User();
    const dataRef = useRef();

    useEffect(() => {
      setTimeout(() => {
        appCRUD.loadActiveAlmanac().then((resp) => {
          setAlmanac(resp.data[0])
        }).catch(() => {})
        appCRUD
          .loadStudentStudyActive(data.id, "-id")
          .then((resp) => {
            setStudy(resp.data[0]);
          })
          .catch(() => {});
      }, 1000)
    },[])
    
    


  const handleConfirmPrint = () => {
    const dataCard = {
      student: data.id,
      academic_year: study.academic_year.id,
      study_year: study.id,
      printed_type: "original",
      issue_date: moment(almanac.start_date).format("YYYY-MM-DD"),
      expiry_date: moment(almanac.end_date).format("YYYY-MM-DD"),
      is_active: true,
      recorded_by: user.id,
    };

    setOpen(false);

    setLoading(true);
    setTimeout(() => {
      appCRUD
        .addCard(dataCard)
        .then(() => {
          setIndex(index + 1);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        })
    }, 1000);
  
  };
    
    

   const handleClearSignature = () => {
         Confirmation(
           `Dear ${char.toTitleCase(user.first_name || "user")}`,
           "did your document printed successfully?",
           handleConfirmPrint,
           () => {
             setOpen(false);
             setLoading(false);
           }
         );
       };

    const handleGeneratePdf = useReactToPrint({
      content: () => dataRef.current,
      onBeforePrint: () => {
        console.log("");
      },
      onAfterPrint: () => {
        handleClearSignature();
      },
    });

    return (
      <>
        {loading && (
          <Loader
            size="lg"
            speed="slow"
            center
            backdrop
            style={{ color: "#d26e29", zIndex: 2000 }}
            content="Please wait..."
            vertical
          />
        )}
        <Modal open={open} onClose={() => setOpen(false)} size="sm">
          <Modal.Header>
            <Modal.Title>New Card</Modal.Title>
          </Modal.Header>
          <Divider />
          <Modal.Body>
            <div
              style={{
                backgroundColor: "whitesmoke",
                display: "flex", // 🔑 Enable Flexbox
                flexDirection: "column", // Stack children vertically
                alignItems: "center", // Center horizontally
                textAlign: "center", // Center inline text
                padding: 10,
              }}
            >
              <div ref={dataRef}>
                <div
                  className="card shadow id-card"
                  style={
                    {
                      // backgroundImage: `url(assets/images/logo/bg1.jpg)`,
                      // marginTop: -20,
                      // marginLeft: -20,
                      // marginRight: -20,
                      // marginBottom: -10,
                    }
                  }
                  hidden={back}
                >
                  <div className="row" style={{ marginTop: -10 }}>
                    <div className="col-2">
                      <img
                        width={40}
                        height={40}
                        className="mt-0 mb-2"
                        src="assets/images/logo/tz.png"
                        alt=""
                      />
                    </div>
                    <div className="col-8">
                      <p
                        className="h6 fw-bold text-center mt-0 front-header"
                        style={{ fontSize: 15, color: "#819031" }}
                      >
                        ARDHI UNIVERSITY
                      </p>
                      <p className="text-center h6 fw-bold fs-10 front-subheader">
                        Official Student Identification
                      </p>
                    </div>
                    <div className="col-2" style={{ marginLeft: -10 }}>
                      <img
                        width={40}
                        height={40}
                        className="mt-0 mb-2"
                        src="assets/images/logo/logo2.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <hr
                        style={{ border: "1px solid #819031", marginTop: -5 }}
                      />
                    </div>
                  </div>
                  <div className="row text-start">
                    <div className="col-8" style={{ marginTop: -10 }}>
                      <div className="row mb-1">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              Name :
                            </span>
                            <span className="text-dark">
                              {data?.full_name
                                ? char.formatName(data.full_name)
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              School :
                            </span>
                            <span className="text-dark">
                              {data?.school
                                ? char.toSmartTitleCase(
                                    data.school.name.replace(
                                      /^school of\s+/i,
                                      ""
                                    )
                                  )
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              Programme :
                            </span>
                            <span className="text-dark">
                              {data?.programme
                                ? char.toSmartTitleCase(data.programme.name)
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              Reg No :
                            </span>
                            <span style={{ color: "#d26e29" }}>
                              {data?.registration_number
                                ? data.registration_number
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              Issue Date :
                            </span>
                            <span className="text-dark">
                              {moment(almanac?.start_date).format(
                                "DD MMMM YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div
                            style={{ display: "flex", fontSize: 8 }}
                            className="h6 fw-bold m-0 font-front"
                          >
                            <span
                              className="text-primary"
                              style={{ minWidth: 57 }}
                            >
                              Expiry Date :
                            </span>
                            <span className="text-danger">
                              {moment(almanac?.end_date).format("DD MMMM YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-4 text-end"
                      style={{ marginTop: -15, marginLeft: -10 }}
                    >
                      <img
                        width={96}
                        height={115}
                        className="mt-0 mb-2 "
                        src={
                          data.photo
                            ? data?.photo
                            : "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                        }
                        alt=""
                        style={{
                          borderRadius: 5,
                          border: "1px solid #ccc",
                          opacity: 0.7,
                          objectFit: "cover", // important for ID photos
                        }}
                      />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: -5 }}>
                    <div className="col-12">
                      <div
                        style={{ display: "flex", fontSize: 8 }}
                        className="h6 fw-bold m-0 font-front"
                      >
                        <p
                          className="text-center mt-0"
                          // style={{ marginLeft: 130 }}
                        >
                          <span
                            className="text-primary"
                            style={{ minWidth: 57 }}
                          >
                            Student Mobilee :
                          </span>
                          <span className="text-dark ms-1">
                            +{data?.phone_number ? data.phone_number : "N/A"}
                          </span>
                          <span className="text-center ms-3 font-front">
                            Student's Signature : 
                          </span>
                          {data.signature && (
                            <img
                              style={{ borderRadius: 10, maxWidth: 40 }}
                              src={data?.signature}
                              alt="student"
                            />
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div style={{ pageBreakAfter: "always" }} /> */}
                <div
                  className="card shadow id-card mt-5 position-relative"
                  style={{
                    overflow: "hidden",
                    transformOrigin: "center",
                  }}
                >
                  {/* WATERMARK */}
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundImage: `url(assets/images/logo/logo2.png)`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "200px 190px",
                      opacity: 0.08, // ✅ watermark effect
                      zIndex: 0,
                      pointerEvents: "none", // ✅ prevent interaction
                    }}
                  />

                  {/* CONTENT */}
                  <div
                    style={{
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    <div className="row" style={{ color: "black" }}>
                      <div className="col-12">
                        <p
                          className="fw-bold text-center back-header"
                          style={{
                            fontSize: 15,
                            color: "#819031",
                            marginTop: -10,
                          }}
                        >
                          ARDHI UNIVERSITY
                        </p>
                      </div>
                    </div>

                    <div className="row" style={{ marginTop: 5 }}>
                      <div className="col-12">
                        <p
                          className="text-center fw-bold font-back"
                          style={{ fontSize: 9 }}
                        >
                          This Identity Card (ID) is property of Ardhi
                          University.
                        </p>

                        <p
                          className="text-center fw-bold font-back"
                          style={{ fontSize: 9, marginTop: 1 }}
                        >
                          If lost and found contact
                        </p>

                        <p
                          className="text-center font-back"
                          style={{ fontSize: 9, marginTop: 2 }}
                        >
                          Deputy Vice Chancellor Academic Affairs
                        </p>

                        <p
                          className="text-center font-back"
                          style={{ fontSize: 9, marginTop: 2 }}
                        >
                          P.O.Box 35176, Dar es Salaam, Tanzania
                        </p>

                        <p
                          className="text-center font-back"
                          style={{ fontSize: 9, marginTop: 2 }}
                        >
                          Direct Line: +255 738 357 330
                        </p>

                        <p
                          className="text-center font-back"
                          style={{ fontSize: 9, marginTop: 2 }}
                        >
                          Email: aru@aru.ac.tz
                        </p>

                        <p
                          className="text-center font-back"
                          style={{ fontSize: 9, marginTop: 2 }}
                        >
                          Website: www.aru.ac.tz
                        </p>

                        <p
                          className="text-center fw-bold font-back"
                          style={{ fontSize: 8, marginTop: 1 }}
                        >
                          or take it to the nearest police station.
                        </p>

                        <p className="text-center" style={{ marginTop: -1 }}>
                          <Image
                            src="/assets/images/logo/muhuri.png"
                            alt="signature"
                            style={{ borderRadius: 10, maxWidth: 70 }}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={loading}
                    onClick={handleGeneratePdf}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-printer-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Print
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );

}